import { Autocomplete, Menu, Button, Paper, Text, Box, Flex, Group } from '@mantine/core'
import classes from './ManageFactory.module.css';
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import { PiDotsThreeOutlineFill } from "react-icons/pi";

import React, { memo, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import TableFactory from './FactoryTableData.component'

const ManageLocation = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
           style={{justifyContent:'space-between'}}
           align="center"
           >
            <Box>
              <Text ta="left" fw={700}>Factory</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Factory name"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/manage-factory/addfactory')}
              >
                Add Factory
              </Button>
              {/* <Button variant="default"><PiDotsThreeOutlineFill/></Button> */}
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <Button variant="default"><PiDotsThreeOutlineFill /></Button>
                </Menu.Target>

                {/* <Menu.Dropdown>
                  <Menu.Item leftSection={<FiFileMinus size={18} />}>
                    Upload csv
                  </Menu.Item>
                  <Menu.Item leftSection={<FaRegFileLines size={18} />}>
                    Upload Excel
                  </Menu.Item>
                  <Menu.Item leftSection={<FiFileText size={18} />}>
                    Upload Google Doc
                  </Menu.Item>
                </Menu.Dropdown> */}
              </Menu>
            </Group>
          </Flex>
          <TableFactory editLink={'/manage-factory/addfactory'} search={sendsearch}/>
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageLocation)
